export const Marquee = ({ items, testId = "marquee" }) => {
  const list = [...items, ...items];
  return (
    <div className="relative border-y border-[#D4AF37]/15 bg-[#0F1D3D] py-4 sm:py-5 overflow-hidden" data-testid={testId} aria-label="Graduate results">
      <div className="marquee-track gap-10 sm:gap-14">
        {list.map((it, i) => (
          <div key={i} className="flex items-center gap-10 sm:gap-14 whitespace-nowrap">
            <span className="font-display text-xl sm:text-2xl text-[#F8F6F0] italic">{it.horse}</span>
            <span className="text-[10px] sm:text-xs tracking-[0.16em] uppercase text-[#AEB7C9]">{it.result}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#6FAE55]" />
          </div>
        ))}
      </div>
    </div>
  );
};
